import { render, staticRenderFns } from "./AdsCard.vue?vue&type=template&id=1ea6bcd0&scoped=true"
import script from "./AdsCard.vue?vue&type=script&lang=js"
export * from "./AdsCard.vue?vue&type=script&lang=js"
import style0 from "./AdsCard.vue?vue&type=style&index=0&id=1ea6bcd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea6bcd0",
  null
  
)

export default component.exports